import * as names from '@/router/route-names'

export default [
  {
    path: '/:accountId/dashboard/documents',
    name: names.DOCUMENTS,
    component: () => import('../views/AccountDocuments.vue'),
  }
]
